module.exports = __webpack_public_path__ + "static/img/J.8692876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/J.png
// module id = bRVY
// module chunks = 0